import { render, staticRenderFns } from "./brand-icon.vue?vue&type=template&id=63d72636&"
import script from "./brand-icon.vue?vue&type=script&lang=js&"
export * from "./brand-icon.vue?vue&type=script&lang=js&"
import style0 from "./brand-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports